export default "__VITE_ASSET__MJRS5pqG__"